// react
import React, { useState } from "react";

// mui
import {
  Card,
  Chip,
  Divider,
  Grid,
  Typography,
  Skeleton,
  Box,
  Tooltip,
} from "@mui/material";

// apexCharts.js
import ReactApexChart from "react-apexcharts";

// styles
import useStyles from "./radialGraphStyles";

// Card-Header
const CardHeader = (props) => {
  var date = props.first.data_received_time;
  const mytime = date.toString();

  // function to get the current time from browser
  var browserDateTime = new Date();
  const browserDate = browserDateTime.toString().slice(4, 15);

  return (
    <div>
      <Grid container sx={{ height: "20%" }}>
        <Grid item container sx={{ padding: "10px" }}>
          <Grid
            item
            xs
            zeroMinWidth
            sx={{ display: "flex", justifyContent: "flex-start" }}
          >
            {props.loadingData ? (
              <Skeleton width="30px" />
            ) : props.first.attribute_name === null ? (
              props.first.attribute_key.length > 14 ? (
                <Tooltip title={props.first.attribute_key} placement="bottom">
                  <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                    {props.first.attribute_key.slice(0, 14) + "..."}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                  {props.first.attribute_key}
                </Typography>
              )
            ) : props.first.attribute_name.length > 14 ? (
              <Tooltip title={props.first.attribute_name} placement="bottom">
                <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                  {props.first.attribute_name.slice(0, 14) + "..."}
                </Typography>
              </Tooltip>
            ) : (
              <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                {props.first.attribute_name}
              </Typography>
            )}
          </Grid>
          <Grid item>
            {mytime.slice(0, 11) != browserDate && (
              <Chip
                variant="outlined"
                label="outdated"
                color="success"
                sx={{ height: "20px", fontFamily: "Poppins, sans-serif" }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </div>
  );
};

// Card-Content
const CardContent = (props) => {
  const max = props.second.max_val;
  function valueToPercent(simulatedValue) {
    return ((simulatedValue * 100) / max).toFixed(3);
  }

  const [series, setSeries] = useState([valueToPercent(props.second.value)]);

  const [options, setOptions] = useState({
    chart: {
      height: 10,
      type: "radialBar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        hollow: {
          margin: 16,
          size: "79%",
        },
        track: {
          background: "#fff",
          strokeWidth: "60%",
          margin: 0,
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 1,
            opacity: 0.2,
          },
        },

        dataLabels: {
          show: true,
          name: {
            offsetY: 40,
            show: true,
            color: "#888",
            fontSize: "18px",
            fontFamily: "Poppins, sans-serif",
          },
          value: {
            formatter: (val) => ((val * max) / 100).toFixed(2),
            color: "#111",
            fontSize: "30px",
            fontWeight: "400",
            show: true,
            offsetY: -3,
          },
        },
      },
    },
    fill: {
      type: "gradient",
      color: "#007fff",
      gradient: {
        type: "horizontal",
        gradientToColors: ["#007fff"],
        stops: [props.second.min_val, props.second.max_val],
      },
    },
    stroke: {
      lineCap: "round",
    },
    labels: [props.second.attribute_uom],
  });

  return (
    <div>
      <Box
        sx={{
          height: "80%",
          display: "grid",
          justifyContent: "center",
          alignContent: "center",
          margin: "20px",
        }}
      >
        {
          props.loadingData ? (
            <Skeleton height={255} />
          ) : typeof props.second.value === "number" ? (
            <ReactApexChart
              sx={{ color: "#007fff" }}
              options={options}
              series={series}
              type="radialBar"
              height={190}
            />
          ) : (
            <Typography
              variant="h6"
              color="#007fff"
              sx={{ margin: "58px auto" }}
            >
              Data Error
            </Typography>
          )

          // <ReactApexChart
          //   sx={{ color: "#007fff" }}
          //   options={options}
          //   series={series}
          //   type="radialBar"
          //   height={190}
          // />
        }
      </Box>
    </div>
  );
};

// Card-Footer
const CardFooter = (props) => {
  var dateTime = props.third.data_received_time.toString();
  return (
    <div>
      <Divider />
      <Grid
        container
        sx={{
          height: "20%",
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          textAlign: "center",
          padding: "8px",
          fontFamily: '"Poppins", sans-serif',
        }}
      >
        {props.loadingData ? (
          <Skeleton width={195} />
        ) : (
          <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
            Received On : {dateTime.slice(0, 23)}
          </Typography>
        )}
      </Grid>
    </div>
  );
};

// RadialGraph Component
const RadialGraph = (props) => {
  const classes = useStyles();
  return (
    <div>
      <Card
        className={classes.root}
        sx={{
          borderRadius: 2,
          width: "300px",
          height: "17em",
        }}
      >
        <CardHeader first={props.value} loadingData={props.loading} />
        <CardContent
          second={props.value}
          loadingData={props.loading}
          sx={{
            display: "grid",
            justifyContent: "center",
            alignContent: "center",
          }}
        />
        <CardFooter third={props.value} loadingData={props.loading} />
      </Card>
    </div>
  );
};
export default RadialGraph;
